import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row g-5 gx-xxl-12" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "col-xxl-12" }
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = { class: "card-body pb-4" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_9 = { class: "d-flex overflow-auto h-55px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetReportInfo = _resolveComponent("WidgetReportInfo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_WidgetReportInfo, {
        ref: "refWidgetReportInfo",
        "widget-classes": "card-xxl-stretch-50 mb-5 mb-xl-8",
        consent_status: "consent_status"
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.isCtmsTabActive && _ctx.isCtmsReportFileAvailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["r-10", {
                  'float-end ': !_ctx.ismobile,
                  'float-start  w-100 mb-2': _ctx.ismobile,
                }]),
                        style: {}
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-sm btn-light", { 'w-100': _ctx.ismobile }]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getFile()))
                        }, [
                          _hoisted_8,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Download")), 1)
                        ], 2)
                      ], 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", {
                  class: _normalizeClass(["nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap", { 'mb-5': _ctx.ismobile }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTabs, (tab) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-item",
                      key: tab.id
                    }, [
                      _createVNode(_component_router_link, {
                        to: tab.path,
                        class: "nav-link text-active-primary me-6",
                        "exact-active-class": "active"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ], 2)
              ]),
              _createVNode(_component_router_view, { "ctms-tab": _ctx.showCtmsTab }, null, 8, ["ctms-tab"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}